module.exports = __webpack_public_path__ + "media/images/flags/cat-d5528eabb6e719a907a74b85b54d67af.svg";